import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Tag from 'components/common/tag/Tag';
import Table from 'components/common/table/Table';
import CustomColumnSelector from 'components/common/table/CustomColumnSelector';

import { ruleHitsTableConfig } from './configFiles/tableConfigs';
import { ruleHitsColumnConfig } from './configFiles/columnConfigs';

import { getRuleHitsData } from 'services/accountInformation';

const mapStateToProps = (state) => {
  const { selectedClientId, accountNumber } = state;

  return { selectedClientId, accountNumber };
};

class RuleHitsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      isLoading: false,
      filteredFields: [],
      selectedColumns: [],
      updatedColumnConfig: {
        field: '',
        isShownByDefault: false,
      },
    };

    this.tableRef = React.createRef(null);
  }

  async componentDidMount() {
    await this.updateTableData();

    this.setState({
      selectedColumns: ruleHitsColumnConfig
        .filter((col) => col.isShownByDefault)
        .map((col) => col.field),
    });
  }

  async componentDidUpdate(prevProps) {
    if (!prevProps.shouldFetchNewData && this.props.shouldFetchNewData) {
      await this.updateTableData();
    }
  }

  updateTableData = async () => {
    const { accountNumber, selectedClientId } = this.props;

    this.setState({
      isLoading: true,
      data: [],
    });

    try {
      const data = await getRuleHitsData(accountNumber, selectedClientId);

      this.setState({
        isLoading: false,
        data,
      });
    } catch (error) {
      this.setState({
        isLoading: false,
        data: [],
      });
    }
  };

  handleCategorySelect = (selectedColumnField) => {
    const { selectedColumns } = this.state;
    const selected = selectedColumns.includes(selectedColumnField);

    if (selected) {
      this.setState({
        selectedColumns: selectedColumns.filter(
          (col) => col !== selectedColumnField
        ),
      });
    }

    if (!selected) {
      this.setState({
        selectedColumns: [...selectedColumns, selectedColumnField],
      });
    }

    this.setState({
      updatedColumnConfig: {
        field: selectedColumnField,
        isShownByDefault: !selected,
      },
    });
  };

  handleDataFiltered = (filters) => {
    const filteredFields = filters.map((filter) => {
      const foundConfig = ruleHitsColumnConfig.find(
        (config) => config.field === filter.field
      );

      if (!foundConfig && foundConfig.title) {
        return '';
      }

      return foundConfig.title;
    });

    this.setState({
      filteredFields,
    });
  };

  handleResetFilters = () => {
    const { tabulator } = this.tableRef.current;

    tabulator.clearHeaderFilter();
  };

  render() {
    const { data, selectedColumns, updatedColumnConfig, filteredFields } =
      this.state;

    return (
      <>
        <div className="d-flex justify-content-end align-items-center column-selector">
          <Tag
            maxWidthInPx={800}
            tags={filteredFields}
            resetTags={this.handleResetFilters}
          />
          <CustomColumnSelector
            columnConfig={ruleHitsColumnConfig}
            handleSelect={this.handleCategorySelect}
            selectedColumns={selectedColumns}
          />
        </div>
        <div className="table">
          <Table
            ref={this.tableRef}
            className={'has-box-shadow'}
            tableConfig={ruleHitsTableConfig}
            columnConfig={ruleHitsColumnConfig}
            data={data}
            selectedColumns={selectedColumns}
            onDataFiltered={this.handleDataFiltered}
            updatedColumnConfig={updatedColumnConfig}
          />
        </div>
      </>
    );
  }
}

RuleHitsTable.propTypes = {
  shouldFetchNewData: PropTypes.bool,
  accountNumber: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  selectedClientId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default connect(mapStateToProps, {})(RuleHitsTable);
